// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__4OFlM","sitemap":"styles_sitemap__ggeoh","sitemap-head":"styles_sitemap-head__FOLhQ","sitemapHead":"styles_sitemap-head__FOLhQ"};